import type { QueryClient } from '@tanstack/react-query';
import { queryRoots } from '@/shared/query';

export function invalidateScheduleList(client: QueryClient): Promise<void> {
  return client.invalidateQueries({
    predicate: (q) => {
      const key = q.queryKey;
      return Array.isArray(key) && key[0] === queryRoots.schedules && key[1] === 'list';
    },
  });
}
